<template lang="pug">
	.easy-creative--tabs(v-if="visibleTabs.length")
		.flex-row
			.adt-tab(v-for="(tab, tabIdx) in visibleTabs", :class="{ 'active': tabIdx === activeTabIdx }", @click="activeTabIdx = tabIdx") {{ tab.Name }}
		.tab-content(v-if="activeTab")
			.flex-row.space(v-for="row in activeTab.Rows", v-if="row.some(f => f && f.__isVisible && !f.__hidden)")
				easy-cretive-question(v-for="(question, idx) in row.filter(f => f.__isVisible)", :question="question", :info="info", :questionTypes="questionTypes", :key="question.Oid",
					:error="requiredExists && question.IsRequired && !question.__filled ? $tCaption('Please answer this question') : null", v-if="!question.__hidden", :class="{ 'disabled-controls': question.__disabled }")
</template>

<script>
	import _ from 'lodash';

	export default {
		translationCategory: 'creative.EasyCreativeTabs',
		name: 'asy-creative--tabs',
		props: ['info', 'question', 'questionTypes', 'requiredExists'],
		data() {
			return {
				activeTabIdx: 0
			};
		},
		computed: {
			visibleTabs() {
				return _.orderBy((this.question.Tabs || []).filter(f => Object.keys(f.Rows).some(key => f.Rows[key].some(r => r.__isVisible && !r.__hidden))), f => f?.Order);
			},
			activeTab() {
				return this.visibleTabs[this.activeTabIdx];
			}
		},
		watch: {
			visibleTabs(v) {
				if (this.activeTabIdx > 0 && this.activeTabIdx >= v?.length) {
					this.activeTabIdx = 0;
				}
			}
		},
		mounted() {
			if (__DEBUG__)
				window.easyCreativeTabs = this;
		},
		methods: {
			
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";
	.easy-creative--tabs {
		.adt-tab {
			border-bottom-left-radius: 0px !important;
			border-bottom-right-radius: 0px !important;
			margin-top: 2px;

			&.active {
				border-top-left-radius: 4px !important;
				border-top-right-radius: 4px !important;
				margin-top: 0px;
			}
		}

		.tab-content {
			min-height: 40px;
			border: 1px solid var(--branding-input-bg);
			width: 100%;
			border-bottom-left-radius: 4px;
			border-bottom-right-radius: 4px;
			border-top-right-radius: 4px;
			margin-top: -1px;
			padding: 20px;
		}
	}
</style>
